import { render } from "./MmbsSvg.vue?vue&type=template&id=0b435dfe&ts=true"
import script from "./MmbsSvg.vue?vue&type=script&lang=ts"
export * from "./MmbsSvg.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__